import React from "react";
import "../styles/Dashboard.css";
import DashboardIcon from "@mui/icons-material/Dashboard";
import { Link } from "react-router-dom";
import ArticleIcon from "@mui/icons-material/Article";
import ReceiptLongIcon from "@mui/icons-material/ReceiptLong";
import DescriptionIcon from "@mui/icons-material/Description";
import CurrencyRupeeIcon from '@mui/icons-material/CurrencyRupee';
import GroupsIcon from '@mui/icons-material/Groups';
function ClassComponent({ className}) {
  return (
    <>
      <div className="col-lg-4">
        <div
          className="card my-2"
          style={{
            position: "relative",
            boxShadow: "rgba(100, 100, 111, 0.2) 0px 7px 9px 0px",
          }}
        >
          <div className="card-body p-4">
            <div className="card-content">
              <p>CLASS : {className}</p>
              <button className="btn btn-warning btn-sm">
                <Link to={`/viewMore/${className}`} style={{ color: "black" }}>
                  view more
                </Link>
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

const Dashboard = () => {
  // const studentDetailsContext = useContext(StudentDetailsContext);

  return (
    <div className="dashboardMainDiv">
      <div className="dashboardMenu">
        <ul className="dashboardDropdownList">
          <div className="listItemContainer activeContainer">
            <li className="listItem">
              <Link className="linkItem" to="/">
                Dashboard
              </Link>
            </li>
            <li className="listItemIcon">
              <DashboardIcon />
            </li>
          </div>

          {/* <div className="listItemContainer">
            <li className="listItem">
              <Link className="linkItem" to="/students">
                Students
              </Link>
            </li>
            <li className="listItemIcon">
              <SchoolIcon />
            </li>
          </div> */}

          {/* <div className="listItemContainer">
            <li className="listItem">
              <Link className="linkItem" to="/analytics">
                Analytics
              </Link>
            </li>
            <li className="listItemIcon">
              <BarChartIcon />
            </li>
          </div> */}

          <div className="listItemContainer">
            <li className="listItem">
              <Link className="linkItem" to="/bonafide">
                Bonafide
              </Link>
            </li>
            <li className="listItemIcon">
              <ArticleIcon />
            </li>
          </div>

          <div className="listItemContainer">
            <li className="listItem">
              <Link className="linkItem" to="/receipt">
                Receipt
              </Link>
            </li>
            <li className="listItemIcon">
              <ReceiptLongIcon />
            </li>
          </div>

          <div className="listItemContainer">
            <li className="listItem">
              <Link className="linkItem" to="/exams">
                Exams
              </Link>
            </li>
            <li className="listItemIcon">
              <DescriptionIcon />
            </li>
          </div>

          <div className="listItemContainer">
            <li className="listItem">
              <Link className="linkItem" to="/feeDetails">
                Fee Details
              </Link>
            </li>
            <li className="listItemIcon">
              <CurrencyRupeeIcon />
            </li>
          </div>

          <div className="listItemContainer">
            <li className="listItem">
              <Link className="linkItem" to="/uploadAttendance">
                Attendance
              </Link>
            </li>
            <li className="listItemIcon">
              <GroupsIcon />
            </li>
          </div>
        </ul>
      </div>
      <div className="dashboardContent">
        <div className="container dashboardContentContainer">
          <div className="row">
            <ClassComponent className="10" />
            <ClassComponent className="9" />
            <ClassComponent className="8" />
            <ClassComponent className="7" />
            <ClassComponent className="6" />
            <ClassComponent className="5" />
            <ClassComponent className="4" />
            <ClassComponent className="3" />
            <ClassComponent className="2" />
            <ClassComponent className="1" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
